module.exports = __webpack_public_path__ + "static/img/banner.0e63097.png";


//////////////////
// WEBPACK FOOTER
// ./static/aboutUs/banner.png
// module id = DJZn
// module chunks = 1